import {LeafletEventHandlerFnMap} from "leaflet";
import {useMapEvents} from "react-leaflet";
import {MapFeatures} from "@ui/leafletCustom/types";

export function useLeafletMapEvents(handlers: LeafletEventHandlerFnMap): MapFeatures {
    return useMapEvents(handlers)
}